import React, {useState, useEffect} from "react";
import {NavLink} from "react-router-dom";
import {Layout, Menu, Icon, notification} from "antd";
import Profile from "@components/profile/index";
import {connect} from "react-redux";
import {ApplicationState} from 'src/reducers';
import {FormattedMessage, injectIntl} from "react-intl";
import {getErrorMessage} from '@utils';
import './index.scss'
import { Scrollbars } from 'react-custom-scrollbars';
import {getUserMenus} from "../../App";
const {Header, Sider, Content, Footer} = Layout;
const {SubMenu} = Menu;

interface MainProps {
}

const MainLayout: React.FC<MainProps> = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const {formatMessage} = props.intl;
  const menuItems = getUserMenus() || [];
  
  useEffect(
    () => {
      const error = props.error;
      
      if (!error) {
        return
      }
      let errorText = "";
      
      const errorMessage = error.data && error.data.meta ? formatMessage(getErrorMessage(error.data.meta)) : "";
      
      if (error.fields) {
        // @ts-ignore
        for (let i = 0; i < error.fields.length; i++) {
          errorText = `${errorText}  ${i + 1}.  ${error.fields[i].key}: ${error.fields[i].messages ? error.fields[i].messages.join() : error.fields[i].value}  `;
        }
      }
      notification["error"]({
        placement: "bottomLeft",
        duration: 10,
        className: "error-server-side",
        message: formatMessage({
          id: "app.error",
          defaultMessage: "Error!"
        }),
        description: errorText || errorMessage
      });
    },
    [props.error]
  );
  
  const toggle = () => {
    setCollapsed(!collapsed);
  };
  
  return (
    <Layout className={`main-layout`}>
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        breakpoint="lg"
        collapsedWidth={60}
        width={240}
      >
        <Scrollbars className={"custom-scrollbar"}
                    renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                    renderView={props => <div {...props} className="view"/>}
                    style={{ height: "100%"}}>
          <div className="logo">
            <img src={config.logo_path}/>
            <span>{config.name}</span>
          </div>
          {/*<NavLink exact to={`/uploads`} params={categoryId:5} activeClassName={HeaderLinkActive}>سبک لباس</NavLink>*/}
          <Menu
            theme="dark"
            defaultOpenKeys={[window.location.hash.split('/')[1]]}
            mode="inline" >
            {menuItems.map(menu => {
              if (menu.subMenu) {
                return (
                  <SubMenu
                    key={menu.key}
                    title={(
                      <a>
                        {menu.icon}
                        <span>{menu.label}</span>
                      </a>
                    )}
                  >
                    {menu.subMenu.map( subMenu => (
                      <Menu.Item key={subMenu.path}>
                        <NavLink exact to={subMenu.path} activeClassName={'panel-active-menu-item'}>
                          {subMenu.icon}
                          <span className="nav-text">{subMenu.label}</span>
                        </NavLink>
                      </Menu.Item>
                    ))}
                  </SubMenu>
                )
              }
              return (
                <Menu.Item key={menu.path}>
                  <NavLink to={menu.path} activeClassName={'panel-active-menu-item'}>
                    {menu.icon}
                    <span className="nav-text">{menu.label}</span>
                  </NavLink>
                </Menu.Item>
              )
            })}
          </Menu>
        </Scrollbars>
       
      </Sider>
      <Layout className={`main-content`}>
        <Header className={"main-layout-header"}>
          <Icon
            className="trigger"
            type={collapsed ? 'menu-fold' : 'menu-unfold'}
            onClick={toggle}
          />
          <Profile/>
        </Header>
        <Content className={"main-layout-content"}>
          {props.children}
        </Content>
        <Footer>Ant Design ©2018 Created by Ant UED</Footer>
      </Layout>
    </Layout>
  );
};


const mapStateToProps = (state: ApplicationState) => ({
  error: state.error.error
});

export default connect(mapStateToProps, null)(
  injectIntl(MainLayout)
);

